import React from 'react';

import { DefaultComponentProps, FormSubmitionValues } from '../../types';

import { CardHeader } from '../CardHeader';
import { CardBody } from '../CardBody';

interface Props extends DefaultComponentProps {
  formSubmitionValues: FormSubmitionValues;
}

export const UserCreated = ({ textConfig, formSubmitionValues }: Props) => {
  const { title, ingress, emoji, emojiLabel } = textConfig.userCreated;
  return (
    <>
      <CardHeader title={title} ingress={ingress} emoji={emoji} emojiLabel={emojiLabel} />
      <CardBody>
        <strong className="card__card-body__value-highlight">{formSubmitionValues && formSubmitionValues.email}</strong>
      </CardBody>
    </>
  );
};
